import PrivacyPage from './privacyPage';
import TermsPage from './termsPage';
import GuidelinesPage from './guidelinesPage';
import FAQPage from './faqPage';

app.initializers.add('morphdev/info-pages', () => {
  app.routes['info-pages.privacy'] = { path: '/privacy', component: PrivacyPage };
  app.routes['info-pages.terms'] = { path: '/terms', component: TermsPage };
  app.routes['info-pages.guidelines'] = { path: '/guidelines', component: GuidelinesPage };
  app.routes['info-pages.faq'] = { path: '/faq', component: FAQPage };
});
